import { render, staticRenderFns } from "./VPlacementsDialogInput.vue?vue&type=template&id=3f0ae5e2"
import script from "./VPlacementsDialogInput.vue?vue&type=script&lang=js"
export * from "./VPlacementsDialogInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports